<template>
  <div class="login-widget">
    <img src="@/assets/logo.jpg" alt="Brickfox Logo" class="logo"/>
    <h1>Kundenlogin</h1>
    <div class="login-text">
      <input type="text" class="text-input" placeholder="Ihr-Unternehmen" @keydown.enter="redirectToCustomer" v-model="customerName"/>
      <span>.brickfox.net</span>
    </div>
    <div>
      <button class="button-input" @click="redirectToCustomer">Anmelden</button>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";

const customerName = ref('')

const redirectToCustomer = () => {
  window.location.href = `https://${customerName.value}.brickfox.net`
}
</script>

<style scoped lang="scss">
.login-widget {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  max-width: 25rem;
  padding: 2rem;

  .logo {
    max-width: 100%;
  }
}

.login-text {
  display: flex;
  flex-direction: row;
  gap: .5rem;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
}

.text-input {
  padding: .5rem 1rem;
  font-size: 1rem;
  width: 100%;

  &:focus {
    outline-color: #ff9900;
  }
}

.button-input {
  padding: .5rem 1rem;
  background: #ff9900;
  color: white;
  border: none;
  font-weight: bold;
  width: 100%;
  border-radius: .25rem;
  margin: 1rem 0;
  font-size: 1rem;
}
</style>
